import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStatus } from '../../hooks/useAuthStatus';
import { useAuth } from '../../contexts/AuthContext';
import LoadingComponent from '../LoadingComponent';

const PrivateRoute = ({ children }) => {
  const { loggedIn, checkingStatus } = useAuthStatus();
  const { userType, loading } = useAuth();
  const location = useLocation();


  if (checkingStatus || loading) {
    return <LoadingComponent/>;
  }

  if (!loggedIn) {
    return <Navigate to="/sign-in" state={{ from: location }} />;
  }
  if (loggedIn && userType === 'isHr') {
    return <Navigate to="/valuator" state={{ from: location }} />;
  }

  return children;
};

export default PrivateRoute;
